import { useState } from 'react'

import { Icon } from '@/icons/Icon'

/**
 * A first password, shown once to whoever is handing it over.
 *
 * The API cannot show this: it never receives the password, only a hash of it
 * (`app/core/client_hash.py`), so this screen is the only place the value
 * exists. Reloading loses it, which is why the panel says so in one line
 * rather than leaving somebody to find out.
 */
export function HandoverPassword({ who, password }: { who: string; password: string }) {
  const [copied, setCopied] = useState(false)

  return (
    <div className="pf-handover">
      <div className="pf-handover__k">First password for {who}</div>
      <div className="pf-handover__pw">
        <code>{password}</code>
        <button
          className="ix-btn ix-btn--secondary ix-btn--compact"
          type="button"
          onClick={() => {
            void navigator.clipboard
              ?.writeText(password)
              .then(() => setCopied(true))
              .catch(() => setCopied(false))
          }}
        >
          <Icon name={copied ? 'check' : 'copy'} size={14} />
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <div className="pf-handover__note">Shown once. They must change it at first sign-in.</div>
    </div>
  )
}

export default HandoverPassword
